export const ACCESS_TOKEN = 'ACCESS_TOKEN';
export const ID_TOKEN = 'ID_TOKEN';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const USER_DATA = 'USER_DATA';
export const ENDPOINTS_DATA = 'ENDPOINTS_DATA';
export const CURRENT_ENDPOINT = 'CURRENT_ENDPOINT';
export const CUSTOM_PRESETS = 'CUSTOM_PRESETS';
